import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AdminRedirect = () => {
  useEffect(() => {
    window.location.href = "https://admin.rashtechinfo.com";
  }, []);

  return null; // No UI is needed
};

export default AdminRedirect;
